import { v4 as uuidv4 } from 'uuid';

export const WEBREG_USER_ID_STORAGE_KEY = 'webregUserId';

export const generateAccessWebregUserId: () => string = () => {
  let userID: string | null = localStorage.getItem(WEBREG_USER_ID_STORAGE_KEY);
  if (!userID) {
    userID = uuidv4();
    localStorage.setItem(WEBREG_USER_ID_STORAGE_KEY, userID as string);
  }
  return userID as string;
};

export const WEBREG_STARTED_STORAGE_KEY = 'webregStarted';

const readStorage = (storage: () => Storage, key: string): string | null => {
  try {
    return storage().getItem(key);
  } catch {
    return null;
  }
};

export const storedWebregUserId = (): string | undefined =>
  readStorage(() => localStorage, WEBREG_USER_ID_STORAGE_KEY) ?? undefined;

let startedBeforeLoad: boolean | undefined;

export const hasStartedWebreg = (): boolean => {
  if (startedBeforeLoad === undefined) {
    startedBeforeLoad = readStorage(() => sessionStorage, WEBREG_STARTED_STORAGE_KEY) === 'true';
  }
  return startedBeforeLoad;
};

export const markWebregStarted = (): void => {
  hasStartedWebreg();
  try {
    sessionStorage.setItem(WEBREG_STARTED_STORAGE_KEY, 'true');
  } catch {
    return;
  }
};
